import axios from 'axios';
import util from '@/common/util';
const initGlobalData = () => {
    return window.sitePrepareData();
};
export const isUnCenterLink2Center = () => {
    // 1.migrationSite: true( Non-middle to middle end )
    // 2.url with parameters ， And the parameters of the belt include  x_ads_source  or  x_ads_id
    let globalData = initGlobalData();
    let { search = '' } = window.location;
    let isUnCenterSite2center = globalData?.migrationSite;
    let isUnCenterLink = search && search.indexOf('condition=') === -1;
    let isAdvertisingLink =
        search.indexOf('x_ads_source') > -1 || search.indexOf('x_ads_id') > -1;
    return (
        !globalData?.isLandingPage &&
        isUnCenterSite2center &&
        isUnCenterLink &&
        isAdvertisingLink
    );
};

export const unCenterLink2CenterParams = params => {
    let searchParams = { ...params };
    if (isUnCenterLink2Center()) {
        delete searchParams.condition;
    }
    // console.groupCollapsed(
    //     'searchRealTimeListings unCenterLink2CenterParams:',
    //     searchParams
    // );
    // console.trace();
    // console.groupEnd();
    return searchParams;
};

export const searchRealTimeListings = params => {
    // console.groupCollapsed('searchRealTimeListings:', params);
    // console.trace();
    // console.groupEnd();
    return axios.get('/api-site/search/realTimeListings', { params });
    // return axios.get(getSearchRequestUrl(), { params });
};

//  Reserve request parameter processing place 
export const handleConditionParams = params => {
    return unCenterLink2CenterParams(params);
};

//  Search interface optimization ， The middle platform uses other separate interfaces 
// Util.setCookie('debug-realTimeListing', true)
export const getSearchRequestUrl = (isMap = false) => {
    if (util.getCookie('debug-realTimeListing')) {
        let globalData = initGlobalData();
        return !globalData.searchCenter
            ? '/api-site/search/realTimeListings'
            : isMap
            ? '/api-site/search/searchMapListing'
            : '/api-site/search/searchListListing';
    } else {
        return '/api-site/search/realTimeListings';
    }
};

export const mergeMlsOrg2HouseList = (houseList, mlsOrgList = []) => {
    return houseList.map(house => {
        if (!house.mlsOrg) {
            house.mlsOrg =
                mlsOrgList.find(mlsOrg => mlsOrg.id === house.mlsOrgId) || {};
        }
        return house;
    });
};
